<div style="top: 0; position: sticky; z-index: 9998;">
   <p-menubar [model]="items|translate:'label':'items'" [autoDisplay]="false">
      <div>
         <button type="button" pButton [label]="'Logout'|translate" icon="pi pi-sign-out"
            [routerLink]="[paths.logout]"></button>
      </div>
   </p-menubar>
</div>
